import { AccountClient } from '../models/account.model'

/**
 * Create ui display string for a given client.
 */
export function displayClient(client: AccountClient) {
  return client.name + ' (' + client.id + ')'
}

/**
 * Check if a list of clients is a single client.
 */
export function checkSingleClient(clients: AccountClient[]) {
  if (clients.length === 0) {
    return false
  }

  const clientIds = clients.map(p => p.id)
  const clientIdsSet = new Set(clientIds)
  return clientIdsSet.size === 1
}

/**
 * Finds the ultimate client data for a given account ID.
 */
export function getUltClientData(
  clients: AccountClient[],
  accountId: number,
): [string, string] {
  const clientData = clients.find(account => account.accountId === accountId)
  return [clientData?.name ?? '', clientData?.id ?? '']
}
